import { FootballTasksUpdate } from 'hooks/useLifecycle';

export const isTaskHighlighted = (value: FootballTasksUpdate | undefined) => {
  return value && value !== 'seen';
};
